"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const index_1 = require("../atoms/index");
const props_1 = require("../common/props");
/**
 * The modal molecule.
 * @category Molecules
 */
class Modal extends molecule_1.Molecule {
    constructor(molecules) {
        super("Modal", molecules);
        this.atoms = this.getDesignSystem().atoms;
        this.color = new props_1.PropertyColorShade("Color", false, this, {
            getSelectables: this.getColorSelectables.bind(this),
            defaultValue: index_1.Shade.BLACK,
        });
        this.borderRadius = new props_1.PropertyNumberSelectable("Border Radius", false, this, [0, 1, 2, 3, 4, 5, 6, 7, 8], 3);
        this.shadow = new props_1.PropertyShadowSelectable("Modal Shadow", false, this);
    }
    getColorSelectables() {
        const ct = this.atoms.colorThemes.getDefaultTheme();
        if (!ct)
            throw new Error("There is no default theme");
        const rtn = [];
        // Black, white, and primary colors
        rtn.push([index_1.Shade.BLACK]);
        rtn.push([index_1.Shade.WHITE]);
        rtn.push([this.getPrimary()]);
        return rtn;
    }
    getPrimary() {
        const ct = this.atoms.colorThemes.getDefaultTheme();
        if (!ct)
            throw new Error("The default color theme was not found");
        const shade = ct.primary.getValue();
        if (!shade)
            throw new Error(`Color theme ${ct.name} does not have a primary color`);
        return shade;
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.borderRadius.deserialize(obj.borderRadius);
        this.shadow.deserialize(obj.shadow);
    }
    serialize() {
        const obj = {};
        obj.borderRadius = this.borderRadius.serialize();
        obj.shadow = this.shadow.serialize();
        return obj;
    }
}
exports.Modal = Modal;
